import UploadModal from './UploadModal';

export default UploadModal;
